import React from "react";

/* ── PriceStamp — the STAMP price treatment (owner pick, 2026-10-14) ──────
 *
 * The $3.99 presented as a postage stamp, from the candidate the owner
 * selected out of the five price treatments: perforated edge, the
 * denomination in the corner box, "A message that matters." as the stamp
 * art, a Fort Pierce postmark straddling the bottom-right corner, and the
 * "Photo postcard / Print + postage incl." mono lines.
 *
 * Geometry follows the candidate (308 x 384) and scales fluidly: the stamp
 * is its own CSS container and every measure inside is in cqw, so the
 * proportions hold at any rendered width. The perforation is generated —
 * one circle per candidate coordinate — and filled with the tone of the
 * surface BEHIND the stamp (set per placement via --cc-stamp-behind), so
 * the notches read as punched out of the page rather than drawn on it.
 *
 * All wording comes from the locale dictionaries (stampArtLines,
 * stampMonoLines, stampPostmarkLines, stampAria in SITE_COPY), so ES/HT
 * render the same stamp in their own words. The stamp states exactly the
 * facts the price text it replaces stated — $3.99 flat, printing and
 * postage included — and nothing else. */

const PERF_XS = [];
for (let cx = 17; cx <= 306; cx += 17) PERF_XS.push(cx);
const PERF_YS = [];
for (let cy = 17; cy <= 374; cy += 17) PERF_YS.push(cy);

function Perforation() {
  return (
    <svg className="cc-stamp-perf" viewBox="0 0 308 384" aria-hidden="true" focusable="false">
      {PERF_XS.map((cx) => (<circle key={`t${cx}`} cx={cx} cy={0} r={5} />))}
      {PERF_XS.map((cx) => (<circle key={`b${cx}`} cx={cx} cy={384} r={5} />))}
      {PERF_YS.map((cy) => (<circle key={`l${cy}`} cx={0} cy={cy} r={5} />))}
      {PERF_YS.map((cy) => (<circle key={`r${cy}`} cx={308} cy={cy} r={5} />))}
    </svg>
  );
}

export function PriceStamp({ t, price }) {
  const art = t.stampArtLines || [];
  const mono = t.stampMonoLines || [];
  // The postmark's first line is the city itself — a proper noun, part of
  // the artwork rather than translatable copy — so it lives here; the
  // remaining postmark lines come from the dictionaries.
  const postmark = ["Fort Pierce", ...(t.stampPostmarkLines || [])];
  return (
    <div className="cc-stamp" role="img" aria-label={t.stampAria}>
      <div className="cc-stamp-in" aria-hidden="true">
        <div className="cc-stamp-top">
          <span className="cc-stamp-brand">CareCard<br />Express</span>
          <span className="cc-stamp-denom">{price}</span>
        </div>
        <div className="cc-stamp-mid">
          <p className="cc-stamp-art">
            {art.map((line, i) => (
              <span
                key={i}
                className={"cc-stamp-art-line" + (i === art.length - 1 ? " cc-stamp-art-accent" : "")}
              >{line}</span>
            ))}
          </p>
          <span className="cc-stamp-rule" />
          <p className="cc-stamp-mono">
            {mono.map((line, i) => (
              <span key={i} className="cc-stamp-mono-line">{line}</span>
            ))}
          </p>
        </div>
        <div className="cc-stamp-postmark">
          {postmark.map((line, i) => (<span key={i}>{line}</span>))}
        </div>
      </div>
      <Perforation />
    </div>
  );
}
